import axios from './axios';

const NoticeService = {
  getNotices: (type) => axios.get('/api/v1/notices', { params: { type } }),
  getNotice: (id) => axios.get(`/api/v1/notices/${id}`),
  createNotice: (data) => axios.post('/api/v1/notices', data),
  updateNotice: (id, data) => axios.put(`/api/v1/notices/${id}`, data),
  deleteNotice: (id) => axios.delete(`/api/v1/notices/${id}`),
};

export default NoticeService;
